
import { Component, LOCALE_ID, Inject, ViewChild, ElementRef } from '@angular/core';
import { interval, mergeMap, Observable, of, retryWhen } from 'rxjs';
import { dasa } from 'src/classess/dasaClasses';
import { test } from 'src/classess/DasaAppUtil';
import { WebSocketService } from './services/web-socket.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

  title = 'dasaapp';
  
  languageList = [
    { code: 'en', label: 'English' },
    { code: 'ge', label: 'Deutsch' },
    { code: 'fr', label: 'Français' }
  ];
  @ViewChild("myBusyDiv") myBusyDiv: ElementRef =  {} as ElementRef;

  messages$: Observable<string[]> = new Observable<string[]>();
  
   constructor(@Inject(LOCALE_ID) protected localeId: string, private wsService: WebSocketService) { }

    ngOnInit(): void {
      // Restore the store's theme before first paint. WhitelevelComponent
      // publishes these tokens, but it only runs on the bootstrap route — a
      // hard refresh or a deep link (bookmarked catering menu, shared invoice)
      // restores the store from session yet leaves the colours at the
      // stylesheet defaults, so the page renders in stock green.
      try {
        test.DasaAppUtil.loadFromSession();
        test.DasaAppUtil.applyThemeFromSession();
      } catch { /* sessionStorage can be unavailable in private mode */ }

      // Push the WebSocket connect off the critical path. The connect+retry
      // logic previously ran during initial bootstrap, competing with the
      // first-paint API calls. requestIdleCallback (or a fallback timeout)
      // lets the browser paint first.
      const start = () => this.connectToWebSocket();
      const ric = (window as any).requestIdleCallback;
      if (typeof ric === 'function') {
        ric(start, { timeout: 2000 });
      } else {
        setTimeout(start, 0);
      }
    }

    connectToWebSocket(){
      this.wsService.listenNewSocket().pipe(
        retryWhen((errors) =>
          errors.pipe(
            mergeMap((error, index) => {
              // Log the error
              console.error(`WebSocket connection error: ${error.message}`);

              // Retry every 5 seconds, up to 10 retries
              if (index < 10) {
                return interval(5000);
              }

              // If 10 retries failed, throw the error
              return of(error);
            })
          )
        )
      ).subscribe(res=>{
        console.log('connection opened from component' , res)
      })
    }

    ngAfterViewInit():void{
      dasa.Utility.busyDivObject = this.myBusyDiv.nativeElement;
      ;
      this.myBusyDiv.nativeElement.style.display ='none';
    }   
}
